import clsx from 'clsx'

import type { WarningTextProps } from './type'

import { WarningFilledIcon } from '@/components/icons/WarningFilled'

import { Icon } from '../icon'
import { WARNING_ICON_SIZE, WARNING_ICON_SPACE } from './const'

export const WarningText = ({ children, size = 'large' }: WarningTextProps) => {
  return (
    <div className={clsx('tw-flex tw-flex-col tw-items-center tw-text-center')}>
      <Icon
        icon={WarningFilledIcon}
        color={'alert'}
        className={clsx(WARNING_ICON_SIZE[size], WARNING_ICON_SPACE[size])}
      />
      {children}
    </div>
  )
}
